import React, { useEffect, useRef } from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';

import Icon from '../../../../Icon';
import styles from './styles.styl';

function Message({
  message,
  autoClose,
  timeout,
  onClose,
  slowConnection,
  formatMessage,
}) {
  const shared = useRef({});

  useEffect(() => {
    shared.current = { onClose };
  }, [onClose]);

  useEffect(() => {
    const timer = autoClose
      ? setTimeout(() => shared.current.onClose(), timeout)
      : null;

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [autoClose]);

  return (
    <div>
      <div className={cn(styles.root, { [styles.hasWarning]: slowConnection })}>
        {message}
        {slowConnection && (
          <div className={styles.slowConnection}>
            <Icon name="connection-slow" size={12} />
            {formatMessage({ id: 'virtualVisit.unstableConnection' })}
          </div>
        )}
      </div>
    </div>
  );
}

Message.propTypes = {
  message: PropTypes.string,
  autoClose: PropTypes.bool,
  slowConnection: PropTypes.bool,
  timeout: PropTypes.number,
  formatMessage: PropTypes.func,
  onClose: PropTypes.func,
};

Message.defaultProps = {
  autoClose: false,
  slowConnection: false,
  onClose: () => {},
};

export default Message;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/Notifications/Message/index.jsx